export class AvailabilityDate {
  date!: string;
  time!: string;
  year!: number;
  month!: number;
  day!: number;
  hour!: number;
  minute!: number;
  weekday!: number;
  hasDay!: boolean;
  hasTime!: boolean;
  past!: boolean;
  present!: boolean;
  future!: boolean;
}
